import { render, staticRenderFns } from "./feeManagement.vue?vue&type=template&id=5fcd842a&"
import script from "./feeManagement.vue?vue&type=script&lang=js&"
export * from "./feeManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports